module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When I first started writing back in the Seventies, my husband Bill and I were retired and traveling all over the States with our home—a 34' travel trailer—in tow. That’s when Bill came up with the great idea of my writing a romance novel set in each one of our fifty states. It was an idea I ultimately accomplished before switching to mainstream fiction and hitting all the international bestseller lists.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As we were preparing to reissue these early titles, I initially planned to update them all—modernize them, so to speak, and bring them into the new high-tech age. Then I realized I couldn’t do that successfully any more than I could take a dress from the Seventies and redesign it into one that would look as if it were made yesterday. That’s when I saw that the true charm of these novels is their look back on another time and another age. Over the years, they have become historical novels, however recent the history. When you read them yourself, I know you will feel the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("So, enjoy, and happy reading to all!")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed4694a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section3.vue
// module id = 78
// module chunks = 0